// Generated by purs version 0.13.0
"use strict";
var $foreign = require("./foreign.js");
module.exports = {
    window: $foreign.window
};
